export interface WebsiteAnalytics {
  id: number;
  restaurantId: number;
  businessId: number;
  hostname: string;
}

export enum AnalyticsDateRangeENUM {
  YESTERDAY = 'yesterday',
  LAST_7_DAYS = 'last7days',
  LAST_14_DAYS = 'last14days',
  LAST_30_DAYS = 'last30days',
  LAST_90_DAYS = 'last90days',
  LAST_6_MONTHS = 'last6months',
  LAST_1_YEAR = 'last1year',
}
